import Swiper from 'swiper';
import { A11y, Keyboard, Navigation, Pagination } from 'swiper/modules';

document.querySelectorAll('.linked-card-slider').forEach((el) => {
	new Swiper(el, {
		modules: [A11y, Keyboard, Navigation, Pagination],
		// Slider only from lg (1024px), two cards per view. Below that it's off
		// and the cards stack — `enabled` is breakpoint-aware, so swiper stops
		// touching transforms and drops its interaction handlers; style.css undoes
		// the flex row. No loop, so the arrows disable at each end.
		enabled: false,
		speed: 700,
		spaceBetween: 24,
		loop: false,
		watchOverflow: true,
		breakpoints: {
			1024: {
				enabled: true,
				slidesPerView: 2,
				slidesPerGroup: 2,
			},
		},
		navigation: {
			prevEl: el.querySelector('.slider-prev'),
			nextEl: el.querySelector('.slider-next'),
		},
		// `custom` rather than `fraction`: fraction counts slides, and with two
		// per group that reads 1/4, 3/4. Custom gets swiper's own page figures —
		// snapIndex and snapGrid.length — so it reads 1/2, 2/2.
		pagination: {
			el: el.querySelector('.slider-pagination'),
			type: 'custom',
			renderCustom: (swiper, current, total) => `${current}/${total}`,
		},
		// Arrow keys move the slider once it has focus.
		keyboard: {
			enabled: true,
			onlyInViewport: true,
		},
		a11y: {
			enabled: true,
			prevSlideMessage: 'Previous cards',
			nextSlideMessage: 'Next cards',
			firstSlideMessage: 'This is the first card',
			lastSlideMessage: 'This is the last card',
			slideRole: 'group',
		},
	});

	/* Not a live region: the user drives every change, and the slides keep
	   role=group and their labels. Strips the wrapper's and notification's. */
	el.querySelectorAll('[aria-live]').forEach((node) => node.removeAttribute('aria-live'));
});
